import { ADICIONAR_PASSAGEIROS_IDA, ALTERAR_COMPRADOR_IDA, ALTERAR_PASSAGEIRO_IDA, ALTERAR_TIPO_EMISSAO_PASSAGEIRO_IDA } from '../../actions/types';

const initialState = undefined

export default function reducerPassageirosIda (state = [], action = initialState) {
  switch (action.type) {
    case ADICIONAR_PASSAGEIROS_IDA: {
      return action.payload
    }
    case ALTERAR_PASSAGEIRO_IDA: {
      const passageiro = action.payload
      const indice = state.indexOf(state.filter(f => f.poltronaId === passageiro.poltronaId)[0])
      const novaPassageiro = Object.assign({}, passageiro)
      const passageiros = Object.assign([], state)
      passageiros[indice] = novaPassageiro

      return passageiros
    }
    case ALTERAR_COMPRADOR_IDA: {
      const passageiro = action.payload;
      const indice = state.indexOf(state.filter(f => f.poltronaId === passageiro.poltronaId)[0]);
      const novaPassageiro = Object.assign({}, passageiro);
      novaPassageiro.ehComprador = !novaPassageiro.ehComprador;
      const passageiros = state
          .map(passageiro => Object.assign({}, passageiro,
              { ehComprador: false }));
      passageiros[indice] = novaPassageiro;

      return passageiros
    }
    case ALTERAR_TIPO_EMISSAO_PASSAGEIRO_IDA: {
      const passageiros = state
      const novaListagem = passageiros
        .map(passageiro => Object.assign({}, passageiro,
          { tipoEmissao: passageiro.tipoEmissao.value ? passageiro.tipoEmissao.value : passageiro.tipoEmissao }))
      return novaListagem
    }
    default:
      return state
  }
}
